import BackupRounded from '@mui/icons-material/BackupRounded';
import { Button } from '@mui/material';
import { useState } from 'react';
import { api } from '../../api/client';
import { useNotify } from '../../lib/notify';
import type { TenantDetail } from './api';

/** Downloads a signed .ppbackup of the shop (GET /platform/tenants/{id}/backup). */
export function TenantBackupButton({ tenant }: { tenant: Pick<TenantDetail, 'id' | 'slug'> }) {
  const notify = useNotify();
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const { data, response, error } = await api.GET('/platform/tenants/{id}/backup', {
        params: { path: { id: tenant.id }, query: { files: 'true' } },
        parseAs: 'blob',
      });
      if (error !== undefined || !response.ok || !(data instanceof Blob)) {
        throw new Error('The backup could not be downloaded.');
      }
      const disposition = response.headers.get('content-disposition') ?? '';
      const match = /filename="([^"]+)"/.exec(disposition);
      const name = match?.[1] ?? `${tenant.slug}.ppbackup`;
      const url = URL.createObjectURL(data);
      const a = document.createElement('a');
      a.href = url;
      a.download = name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      notify.success('Backup downloaded');
    } catch (e) {
      notify.error(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={<BackupRounded />}
      loading={busy}
      onClick={() => void download()}
    >
      Backup
    </Button>
  );
}
